// ============================================================================
// chatNavigation.ts — ЕДИНАЯ точка переходов ИЗ чата (SSoT/SRP).
//   • открыть диалог (полный чат) — публикация: state {chat, convId};
//     конфигуратор: /designer/chat?conv=<id>.
//   • открыть запись объекта (например, из карточки «О сущности» в правой
//     панели) — публикация: state {objectType, objectName, recordId};
//     конфигуратор: /designer/object/<тип>/<код>?id=<id>.
// Публикация — state-based (URL /enterprise/{slug} не меняется).
// ============================================================================

import { navigateTo } from '@/lib/navigate';

function enterpriseSlug(): string {
  const m = window.location.pathname.match(/^\/enterprise\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

/** Открыть переписку чата по id (общий путь для уведомлений и панели «О чате»). */
export function openConversation(convId: string): void {
  if (!convId) return;
  const slug = enterpriseSlug();
  if (slug) {
    navigateTo(`/enterprise/${encodeURIComponent(slug)}`, { state: { chat: true, convId } });
    return;
  }
  navigateTo(`/designer/chat?conv=${encodeURIComponent(convId)}`);
}

/** Открыть запись объекта метаданных (список/форма — как в оболочке платформы). */
export function openObjectRecord(objectType: string, objectCode: string, objectId: string): void {
  if (!objectType || !objectCode || !objectId) return;
  const slug = enterpriseSlug();
  if (slug) {
    navigateTo(`/enterprise/${encodeURIComponent(slug)}`, {
      state: { objectType, objectName: objectCode, recordId: objectId, from: 'home' },
    });
    return;
  }
  navigateTo(`/designer/object/${encodeURIComponent(objectType)}/${encodeURIComponent(objectCode)}?id=${encodeURIComponent(objectId)}`);
}
